import { UsedProductFamily } from "@/@types";
import { ApiClient } from "../../ApiClient";
import { GetUsedProductsFamiliesResponse } from "../schema/GetUsedProductsFamiliesResponse";
import { mapUsedProductsFamily } from "../../mappers/usedProductFamilyMapper";

export const getUsedProductsFamilies = async (): Promise<UsedProductFamily[]> => {
    const client = ApiClient.getInstance();
    
    const response = await client.get<GetUsedProductsFamiliesResponse>('used-products/families')

    const mappedResponse = response.data.map(mapUsedProductsFamily)

    return mappedResponse;
}